export default "__VITE_ASSET__221efe2b__"